const entityGroupTable = {
    Admin: [
        'Accounts',
        'AdvancedCommunications',
        'AuthorizationRoles',
        'AuthorizationScopes',
        'Companies',
        'CompanyInvitations'
    ],
    Architect: [
        'Areas',
        'Campuses',
        'Clients',
        'Contacts',
        'Equipment',
        'Sites',
        'Systems'
    ],
    IoTHub: [
        'Agents',
        'Profiles'
    ],
    Reporting: [
        'InspectionReports'
    ],
    Rules: [
        'Rules'
    ],
    ServiceManagement: [
        'ServiceCalls',
        'ServiceAppointments'
    ],
    Subscriptions: [
        'Subscriptions'
    ]
};

const EntityGroupTypes = Object.keys(entityGroupTable);

const getEntityGroup = entity => {
    const groups = Object.keys(entityGroupTable);
    let targetEntity, targetGroup;

    for (const group of groups) {
        targetEntity = entityGroupTable[group].find(item => item === entity);

        if (targetEntity) {
            targetGroup = group;

            break;
        }
    }

    return targetGroup;
};

export { getEntityGroup, EntityGroupTypes };
